import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import PriorityForm from './forms/priorityForm';
import PriorityFieldForm from './forms/priorityFieldForm';
import PriorityList from './lists/priorityList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import None from "./None";

class FieldEditor extends React.Component {
    render() {
        return <Fragment>
            {this.props.children}
            <div className="col-md-2">
                <div className="form-group">
                    <label className="control-label">&nbsp;</label>
                    {this.props.footer}
                </div>
            </div>
        </Fragment>;
    }
}

class priorityEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        let List = this.props.list || Box;
        let Editor = this.props.editor || BoxEditor;
        let Form = PriorityForm;
        if (this.props.presets.option_type) {
            Editor = FieldEditor;
            List = None;
            Form = PriorityFieldForm;
        }
        List = <List
            {...this.props}
            collapsed={this.props.collapsed || false}
            theme="default"
            header={"Url-ek"}
            footer={[
                <Button
                    key="0"
                    disabled={this.props.isLoading}
                    color="default"
                    onClick={this.pristineForm}
                >
                    Új
                </Button>
            ]}
        >
            <PriorityList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
        </List>;
        Editor = <Editor
                {...this.props}
                ref={(editor) => this.editor = editor}
                theme="default"
                header={"Url"}
                footer={[
                    <Button
                        key="0"
                        disabled={this.props.presets.option_type ? !this.props.dirty || this.props.isLoading : !this.props.presets.option_id || this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                        block={!!this.props.presets.option_type}
                        color="primary"
                        onClick={this.saveForm}
                    >
                        Kiemelés
                    </Button>
                ]}
            >
                <Form {...this.props} />
            </Editor>;
        if (this.props.presets.option_type) {
            return <div className="row">
                {Editor}
                {List}
            </div>;
        } else {
            return <Fragment>
                {List}
                {Editor}
            </Fragment>;
        }
    }
}

export default createEditor({componentName: "priority", WrappedComponent: priorityEditor});
